import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Snackbar,
  Alert,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DescriptionNameTypeCategorys from "../../../../components/DescriptionNameType/DescriptionNameTypeCategorys";
import DescriptionNameTypeSubCategorys from "../../../../components/DescriptionNameType/DescriptionNameTypeSubCategorys";
import DescriptionNameTypeNameField from "../../../../components/DescriptionNameType/DescriptionNameTypeNameField";
import DescriptionTypesField from "../../../../components/DescriptionNameType/DescriptionTypesField";
import CancelButton from "../../../../components/MinorComponents/CancelButton";
import { useAuthHeaders } from "../../../../components/Token";
import { POSTVendorDESC } from "../../../../services/api/Descriptions";
import { API_BASE_URL } from "../../../../utils";
import { POSTVendorDESCTYpe } from "../../../../services/api/DescriptionType";

export default function CreateDescriptionNameVendorTypes() {
  const [category, setCategory] = useState([]);
  const [submitCategory, setSubmitCategory] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [subCategory, setSubCategory] = useState([]);
  const [submitSubCategory, setSubmitSubCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [descriptionNameType, setDescriptionNameType] = useState([]);
  const [createDescriptionNameType, setCreateDescriptionNameType] = useState([]);
  const [selectedDescriptionNameType, setSelectedDescriptionNameType] = useState("");
  const [discriptionMethod, setDiscriptionMethod] = useState([]);
  const [selectedDescriptionMethod, setSelectedDescriptionMethod] = useState("");
  const [tags, setTags] = useState([]);
  const textValues = tags.map((item) => item.text);
  const subdomain = localStorage.getItem("vendorsubdomain");

  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const navigate = useNavigate();
  const headers = useAuthHeaders();

  useEffect(() => {
    axios.get(`${API_BASE_URL}/category/admin/getcategory`, { headers })
      .then((res) => setCategory(res.data?.categories))
      .catch((err) => console.error("Category error:", err));

    axios.get(`${API_BASE_URL}/type/admin/gettypes`, { headers })
      .then((res) => setDiscriptionMethod(res?.data?.types))
      .catch((err) => console.error("Type fetch error:", err));
  }, []);

  const handleCategoryCreation = async (e) => {
    e.preventDefault();

    const payload = {
      categoryname: submitCategory,
      subcategoryname: submitSubCategory,
      descriptionname: selectedDescriptionNameType,
      type: selectedDescriptionMethod,
      descriptionnametypes: textValues,
    };

    try {
      const response = await POSTVendorDESCTYpe(subdomain, payload);
      if (response.data.success) {

        setSnackbar({ open: true, message: response?.data?.message, severity: "success" });
      } else {
        setSnackbar({ open: true, message: response.data.message, severity: "error" });
      }
    } catch (error) {
      console.error("Submit error:", error);
      setSnackbar({ open: true, message: "Failed to create. Try again.", severity: "error" });
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Create Description Name Types
      </Typography>

      <Box component="form" onSubmit={handleCategoryCreation} sx={{ padding: 3, boxShadow: 3, borderRadius: 2 }}>
        <Grid container spacing={1}>

          <DescriptionNameTypeCategorys
            setSelectedCategory={setSelectedCategory}
            selectedCategory={selectedCategory}
            category={category}
            setSubCategory={setSubCategory}
            setSubmitCategory={setSubmitCategory}
          />

          <DescriptionNameTypeSubCategorys
            selectedSubCategory={selectedSubCategory}
            setSelectedSubCategory={setSelectedSubCategory}
            subCategory={subCategory}
            setDescriptionNameType={setDescriptionNameType}
            setSubmitSubCategory={setSubmitSubCategory}
          />

          <DescriptionNameTypeNameField
            setCreateDescriptionNameType={setCreateDescriptionNameType}
            createDescriptionNameType={createDescriptionNameType}
            descriptionNameType={descriptionNameType}
            setSelectedDescriptionNameType={setSelectedDescriptionNameType}
            selectedDescriptionNameType={selectedDescriptionNameType}
          />

          <Grid item xs={12} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel id="type-label">Type</InputLabel>
              <Select
                labelId="type-label"
                value={selectedDescriptionMethod}
                onChange={(e) => setSelectedDescriptionMethod(e.target.value)}
              >
                <MenuItem value="">
                  <em>Select Description Method</em>
                </MenuItem>
                {discriptionMethod?.map((method) => (
                  <MenuItem key={method._id} value={method.name}>
                    {method.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {(selectedDescriptionMethod === "Drop Down" || selectedDescriptionMethod === "Check Box") && (
            <Grid item xs={12} md={4}>
              <DescriptionTypesField setTags={setTags} tags={tags} />
            </Grid>
          )}
        </Grid>

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button type="submit" variant="contained" sx={{ backgroundColor: "#0443C0" }}>
            Save
          </Button>
          <CancelButton path={`/${subdomain}/master/description-type`} />
        </Box>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
